import React from "react";

const ActiveFilterChips = ({ chips = [] }) => {
  if (!chips.length) return null;

  return (
    <div className="active-filter-chips" aria-label="Filter aktif">
      <span className="active-filter-chips-label">Filter aktif:</span>
      <div className="active-filter-chips-list">
        {chips.map((chip) => (
          <span className="active-filter-chip" key={chip.key}>
            <span>{chip.label}</span>
            <button
              type="button"
              className="active-filter-chip-remove"
              aria-label={`Hapus filter ${chip.label}`}
              onClick={chip.onRemove}
            >
              <span className="material-icons-round" aria-hidden="true">close</span>
            </button>
          </span>
        ))}
      </div>
    </div>
  );
};

export default ActiveFilterChips;
